import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "./RowSelector.module.css";

/**
 * Interactive component. Provides an interface to select one of four rows for a category in the TagMonster.
 */
export function RowSelector({ value, onChange }) {
  return (
    <div className={styles.container}>
      <button
        className={classNames(styles.selectorButton, {
          [styles.selected]: value === 1,
        })}
        onClick={(e) => {
          e.preventDefault();
          onChange(1);
        }}
      >
        1
      </button>
      <button
        className={classNames(styles.selectorButton, {
          [styles.selected]: value === 2,
        })}
        onClick={(e) => {
          e.preventDefault();
          onChange(2);
        }}
      >
        2
      </button>
      <button
        className={classNames(styles.selectorButton, {
          [styles.selected]: value === 3,
        })}
        onClick={(e) => {
          e.preventDefault();
          onChange(3);
        }}
      >
        3
      </button>
      <button
        className={classNames(styles.selectorButton, {
          [styles.selected]: value === 4,
        })}
        onClick={(e) => {
          e.preventDefault();
          onChange(4);
        }}
      >
        4
      </button>
    </div>
  );
}

RowSelector.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};
